import React, { useEffect, useState } from 'react';
import { Modal, Button } from 'react-bootstrap'
import { getSettlementData } from '../../../seller-apis/apidataField';
import api from '../../../seller-apis/api';
import '../../../assets/css/payment.css'
import PaymentCard from '../../common/PaymentCard';
import { useAlert } from 'react-alert';
import moment from 'moment';
import MainLoader from '../../common/Loader/PageLoader';

var allscrollLen = 0;
var globalFilter = {
    "pageNo": 1,
    "filters": {
        "requestForPayment-id": "penality-deduction",
        "action": "APPROVE"
    },
    "sortFilter": { "_id": -1 }
};
var sorted = false;

const SettlementsPenalty = () => {
    var outerdiv;
    var loaderDiv;

    const alert = useAlert();


    // Web states
    const [allRecords, setallRecords] = useState();
    const [settlementData, setsettlementData] = useState({});

    // Dates
    const [datefrom, setdatefrom] = useState(moment().subtract(29, 'days').format('YYYY-MM-DD'))
    const [dateto, setdateto] = useState(moment().format('YYYY-MM-DD'))
    const [isDateValid, setisDateValid] = useState(false)
    // Loader 
    const [ennewloader, setennewloader] = useState("block");

    // Pagination related
    const [selectedPage, setSelectedPage] = useState(1);
    const [compforPaginationweb, setcompforPaginationweb] = useState("allData");


    // Scroll related events


    const [isallcrollBtnVis, setisallcrollBtnVis] = useState("none");
    const [loadText, setloadText] = useState("Load More")

    // Sorting related states
    const [currstatesort, setcurrstatesort] = useState("State*");
    const [currstatussort, setcurrstatussort] = useState("Status*")

    // Filter related states

    const [orderId, setOrderId] = useState("")

    // Modal for payment history

    const [show, setShow] = useState(false);
    const [currPayHistno, setcurrPayHistno] = useState(0)

    const [removeFilterClass, setremoveFilterClass] = useState("invent_remove_filter_btn")

    useEffect(() => {
        allscrollLen = 1;
        dateSortFun();
    }, [])


    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    // check event

    function checkevent(e) {
        if (e.keyCode === 13) {

            if (orderId !== "") {
                globalFilter.pageNo = 1
                allscrollLen = 1
                if (!globalFilter.orderId) {
                    globalFilter.filters = { ...globalFilter.filters, "orderId": orderId }
                }
                applyLoader()
                setremoveFilterClass("invent_remove_filter_btn_active")
                api.vendorledger.getPaymentRequests(getSettlementData(globalFilter)).then((res) => {
                    console.log(res)
                    setsettlementData(res.data)
                    setallRecords(res.totalRecords)
                    if (res.totalRecords < 1) {
                        alert.info("No records found")
                    }
                    removeLoader()
                    setcompforPaginationweb("orderId")
                }).catch(err => {
                    console.log(err)
                    alert.error("Unable to search at this time")
                    removeLoader()
                    setcompforPaginationweb("orderId")
                })

            }
            else if (orderId === "" && compforPaginationweb === "orderId") {
                setcompforPaginationweb("allData")
                applyLoader()
                console.log(globalFilter)
                let { orderId, ...rest } = globalFilter.filters
                globalFilter.filters = { ...rest }
                setremoveFilterClass("invent_remove_filter_btn")
                allscrollLen = 1;
                globalFilter.pageNo = 1;
                api.vendorledger.getPaymentRequests(getSettlementData(globalFilter)).then((res) => {
                    console.log(res)
                    setsettlementData(res.data)
                    setallRecords(res.totalRecords)
                    removeLoader()
                }).catch(err => {
                    console.log(err)
                    removeLoader()
                })
            }
        }
    }

    const sort = (field) => {
        globalFilter.sortFilter = {};
        if (sorted) {
            sorted = false;
            globalFilter.sortFilter[field] = 1;
        } else {
            sorted = true;
            globalFilter.sortFilter[field] = -1;
        }
        // settlement onhold api

        api.vendorledger.getPaymentRequests(getSettlementData(globalFilter)).then((res) => {
            console.log(res)
            setsettlementData(res.data)
            setallRecords(res.totalRecords)
            setennewloader("none")
        }).catch(err => console.log(err))
    }

    // Date sorting

    const dateSortFun = () => {
        if (datefrom === "" || datefrom === undefined || dateto === "" || dateto === undefined) {
            alert.info("Please select a date range")
        }
        else {
            let fromDate = new Date(datefrom)
            let toDate = new Date(dateto);
            let diffDate = toDate.getTime() - fromDate.getTime()
            let daydiffer = diffDate / (1000 * 60 * 60 * 24);
            daydiffer = Math.floor(daydiffer)
            console.log(daydiffer)
            if (daydiffer < 0) {
                setisDateValid(false)
                alert.info("Please select a valid date range.")
            } else if (daydiffer > 30) {
                setisDateValid(false)
                alert.info("Date range cannot be more than 30 days.")
            }
            else {
                setisDateValid(true)
                applyLoader()
                globalFilter.pageNo = 1
                globalFilter.filters = {
                    ...globalFilter.filters,
                    "from-createdAt": datefrom + 'T00:00:00',
                    "to-createdAt": dateto + 'T23:59:59'
                }
                setremoveFilterClass("invent_remove_filter_btn_active")
                api.vendorledger.getPaymentRequests(getSettlementData(globalFilter)).then((res) => {
                    allscrollLen = 1;
                    setcompforPaginationweb("dateSort")
                    setsettlementData(res.data)
                    setallRecords(res.totalRecords)
                    removeLoader()
                }).catch(err => console.log(err))
            }
        }
    }

    // load more 

    function loadMore() {
        if (loadText !== "Loading...") {
            setloadText("Loading...")
            allscrollLen = allscrollLen + 1;
            globalFilter.pageNo = allscrollLen
            api.vendorledger.getPaymentRequests(getSettlementData(globalFilter)).then((res) => {
                setloadText("Load more")
                setsettlementData(settlementData => settlementData.concat(res.data))
            }).catch(err => console.log(err))
        }
    }


    // apply loaders

    function applyLoader() {
        outerdiv = document.getElementById("order_summary_Tab");
        loaderDiv = document.getElementById("enNewLoader");
        loaderDiv.classList.add("loader-bt");
        setennewloader("flex")
        outerdiv.classList.add("div-bk");
    }

    // remove loader

    function removeLoader() {
        loaderDiv.classList.remove("loader-bt");
        setennewloader("none")
        outerdiv.classList.remove("div-bk");
    }

    // Show payment history

    function showpayhistory(e) {
        console.log(e)
        setcurrPayHistno(e)
        handleShow()
    }


    return (

        <div id="orDeskContain" className='mb-4'>
            <div className="tab">
                <div className="contain_payment_table mx-2">
                    <div className='d-flex mb-3 justify-content-around'>

                        {/* Date container */}
                        <div className='theme-shed1 p-2'>
                            <div className='m-auto mt-1'>
                                <span className='payment_dates'>From: - <input type='date' value={datefrom} onChange={(e) => setdatefrom(e.target.value)}></input></span>
                                <span className='mx-2 payment_dates'>To: - <input type='date' value={dateto} onChange={(e) => setdateto(e.target.value)}></input></span>
                                <span><button className='apply-btn px-3 py-1 ff_Pop fs-14' onClick={() => dateSortFun()}>Apply</button></span>
                                {/* <span><button className={`payment_btn_export px-3 py-1 ff_Pop fs-14 ms-1 ${removeFilterClass}`} onClick={() => clearFilter()}>Clear</button></span> */}
                            </div>
                        </div>
                        {/* <div className='p-2'>
                    <button className='payment_summary_btns me-2'>Total Orders ({summaryData.totalOrders})</button>
                    <button className='payment_summary_btns me-2'>Total Transfer price (<i class="fa fa-inr" aria-hidden="true"></i> {summaryData.totalTransferPrice})</button>
                </div> */}
                        {/* Export button */}
                        {/* <div className='p-2'>
                    <button className="px-3 py-1 ff_Pop payment_btn_export fs-17" id="export_Btn" onClick={() => exportToSheet()}>Export to Sheet <i class="bi bi-file-earmark-spreadsheet"></i></button>
                </div> */}
                    </div>
                    <div className='table-responsive'>
                        <table className='payment_table' style={{ "width": "100%" }} id="order_summary_Tab">
                            <thead>
                                <tr className='table_ord_title_row'>

                                    <th className='thead_title' style={{ "width": "10%" }}>S. No.
                                    </th>

                                    <th className='thead_title' style={{ "width": "25%" }}>Payment Deduct On
                                        <i class="fa fa-sort" onClick={() => sort('createdAt')}></i>
                                    </th>

                                    <th className='thead_title pb-1' style={{ "width": "15%" }}>Order Id
                                        <br></br>
                                        <input type="text" value={orderId} name="name" placeholder='Search' className='w-90 order_table_srch_input' onChange={(e) => setOrderId(e.target.value)} onKeyUp={(e) => checkevent(e, "id")} />
                                    </th>

                                    <th className='thead_title' style={{ "width": "20%" }}>Amount
                                    </th>

                                    <th className='thead_title text-black' style={{ "width": "30%" }}>Reason
                                    </th>

                                </tr>

                            </thead>
                            <tbody>
                                {settlementData.length > 0 ? settlementData.map((item, index) => {
                                    let date = new Date(item.createdAt);
                                    let d = date.toUTCString(item.createdAt);
                                    let newd = d.substr(4, 12)
                                    return (
                                        <PaymentCard id={index}
                                            date={newd}
                                            item={item}
                                            deducton={newd}
                                            orderId={item?.orderId}
                                            amount={item?.amount}
                                            reason={item?.reason}
                                            requestForPayment={item?.requestForPayment}
                                            from="paymentsPenalty"
                                        />
                                    )

                                }) : <>

                                </>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="d-flex justify-content-center" id="enNewLoader" >
                    <div style={{ "display": ennewloader }}>
                        <MainLoader/>
                    </div>
                </div>

                {allscrollLen * 15 < allRecords ? <div className='loadMorecntn d-flex justify-content-center '>
                    <button className='payment_btn_export mt-4' onClick={() => loadMore()}>{loadText}</button>
                </div> : isallcrollBtnVis === "block" ? <><p className="pageendTxt text-center ff_pop mt-4">Looks like you have reached bottom of the page</p></> : <></>}


                <div className='scrolltoptnCnt' style={{ "display": isallcrollBtnVis }}>
                    <a href='#orDeskContain'>
                        <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                    </a>

                </div>



            </div>


            {/* Popup */}
            <Modal show={show} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title className="popup_settlement_title">{settlementData && settlementData.length > 0 ? <>Tx.Id - <span className='theme-col'>{settlementData[currPayHistno].txId}</span></> : <></>}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {settlementData && settlementData.length > 0 && settlementData[currPayHistno].payHistory && settlementData[currPayHistno].payHistory.length > 0 &&
                        <>
                            <table className='payment_table mb-2' style={{ "width": "100%" }} id="order_summary_Tab">
                                <thead>
                                    <tr className='table_ord_title_row'>

                                        <th className='thead_title' style={{ "width": "20%" }}>Order Id
                                        </th>

                                        <th className='thead_title pb-1' style={{ "width": "20%" }}>Amount
                                        </th>
                                    </tr>

                                </thead>
                                <tbody>
                                    {settlementData[currPayHistno].payHistory.map((item, index) => {
                                        return (
                                            <>
                                                <tr key={index}>
                                                    <td className='order_table_date'> {item.orderId}</td>
                                                    <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {item.amount}</td>
                                                </tr>
                                            </>
                                        )
                                    })}

                                    <tr className='settlement_pop_total_hist table_ord_title_row'>
                                        <th className='thead_title text-black'><span className='text-underline thead_title fs-11'>Total Amount</span></th>
                                        <td className='order_table_date'><i class="fa fa-inr" aria-hidden="true"></i> {settlementData[currPayHistno].totalAmount}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </>
                    }
                </Modal.Body>

            </Modal>
        </div>
    )
}

export default SettlementsPenalty